import { Component, OnInit, inject } from '@angular/core';
import { VersionService } from '../../../services/version.service';
import { ApplicationVersionDto } from '../../../models/dto/application-version.dto';

@Component({
    selector: 'app-version-info',
    standalone: true,
    template: `
        @if (versionInfo) {
            <div class="version-info" [title]="tooltip">
                UI {{ versionInfo.frontend.version || 'n/d' }} · BE {{ versionInfo.backend.version || 'n/d' }}
            </div>
        }
    `,
    styles: [`
        .version-info {
            position: fixed;
            right: 1rem;
            bottom: .5rem;
            z-index: 40;
            padding: .15rem .45rem;
            border-radius: 4px;
            background: rgba(255, 255, 255, .82);
            color: #64748b;
            font-size: .72rem;
            line-height: 1.2;
            box-shadow: 0 1px 3px rgba(15, 23, 42, .08);
        }
    `]
})
export class AppVersionInfo implements OnInit {
    private readonly versionService = inject(VersionService);

    versionInfo?: ApplicationVersionDto;

    get tooltip(): string {
        if (!this.versionInfo) {
            return '';
        }
        return [
            `UI: ${this.versionInfo.frontend.name || 'n/d'} ${this.versionInfo.frontend.version || 'n/d'}`,
            `BE: ${this.versionInfo.backend.name || 'n/d'} ${this.versionInfo.backend.version || 'n/d'}`,
            `UI build: ${this.versionInfo.frontend.buildTime || 'n/d'}`,
            `BE build: ${this.versionInfo.backend.buildTime || 'n/d'}`
        ].join('\n');
    }

    ngOnInit(): void {
        this.versionService.getVersion().subscribe(versionInfo => this.versionInfo = versionInfo);
    }
}
